import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, Task, TaskService } from '../../../../../../core';
import { PedidoIntegracaoImportFilter } from '../../../pedido-integracao-import-filter';
import { PedidoIntegracaoEcommerceImportHttpService } from '../pedido-integracao-ecommerce-import-http.service';
import { PedidoIntegracaoEcommerceImportService } from '../pedido-integracao-ecommerce-import.service';
import { Integracao, IntegracaoEcommerceHttpService } from '../../../../../integracao';

@Component({
    selector: 'sgt-pedido-integracao-ecommerce-import-modal',
    templateUrl: './pedido-integracao-ecommerce-import-modal.component.html',
    styleUrls: ['./pedido-integracao-ecommerce-import-modal.component.less']
})
export class PedidoIntegracaoEcommerceImportModalComponent implements OnInit {
    filter: PedidoIntegracaoImportFilter;
    elModal: any;

    @ViewChild('form') form: NgForm;
    integracoes: Integracao[];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private taskService: TaskService,
                private integracaoEcommerceHttpService: IntegracaoEcommerceHttpService,
                private pedidoIntegracaoEcommerceImportService: PedidoIntegracaoEcommerceImportService,
                private pedidoIntegracaoEcommerceImportHttpService: PedidoIntegracaoEcommerceImportHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.filter = new PedidoIntegracaoImportFilter();
                this.searchIntegracoes();
                jQuery(this.elModal).find('#integrationPedidoPeriodicidade').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Pesquisa as integrações ativas do tipo e-commerce */
    private searchIntegracoes() {
        try {
            this.integracoes = [];
            this.integracaoEcommerceHttpService.searchAtivas()
                .subscribe(
                    integracoes => {
                        this.integracoes = integracoes;
                        if (this.integracoes?.length === 1) {
                            this.filter.idIntegracao = this.integracoes[0].id;
                        }
                    },
                    (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as integrações ativas do tipo e-commerce', error)
                );
        } catch (error) {
            this.messageService.error('Erro ao pesquisar as integrações ativas do tipo e-commerce', 'Erro', error);
        }
    }

    private clear() {
        this.filter = null;
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    import() {
        if (this.form.valid) {
            const task = new Task('Importando pedidos do e-commerce', 'Realizando importação dos pedidos do e-commerce');
            this.taskService.add(task, task.description);
            this.pedidoIntegracaoEcommerceImportHttpService.import(this.filter)
                .subscribe(
                    (response: any) => {
                        this.taskService.success(task, 'Importação dos pedidos do e-commerce realizada com sucesso');
                        this.pedidoIntegracaoEcommerceImportService.emitAfterImport();
                    },
                    (error: ApiError) => {
                        this.taskService.error(task, error.message, error.cause, error);
                    }
                );

            this.close();
        } else {
            this.messageService.info('Informe todos os campos corretamente para importar os pedidos do e-commerce', 'Informação');
        }
    }
}
